export class ArgumentNullException extends Error {
    constructor() {
        super(...arguments);
        this.name = "ArgumentNullException";
    }
}
export class BadArgumentException extends Error {
    constructor() {
        super(...arguments);
        this.name = "BadArgumentException";
    }
}
export class NotImplementedException extends Error {
    constructor() {
        super(...arguments);
        this.name = "NotImplementedException";
    }
}
export class InvalidConfigurationError extends Error {
    constructor() {
        super(...arguments);
        this.name = "InvalidConfigurationError";
    }
}
export class InvalidOperationException extends Error {
    constructor() {
        super(...arguments);
        this.name = "InvalidOperationException";
    }
}
export class UnauthorizedError extends Error {
    constructor() {
        super(...arguments);
        this.name = "UnauthorizedError";
        this.skipReporting = true;
        this.errorType = "UNAUTHORIZED";
        this.extensions = {
            name: this.name,
            errorType: this.errorType,
        };
    }
}
export class UnauthenticatedError extends Error {
    constructor() {
        super(...arguments);
        this.name = "UnauthenticatedError";
        this.skipReporting = true;
        this.errorType = "UNAUTHENTICATED";
        this.extensions = {
            name: this.name,
            errorType: this.errorType,
        };
    }
}
export class PermissionsNotFoundError extends Error {
    constructor() {
        super(...arguments);
        this.name = "PermissionsNotFoundError";
        this.skipReporting = true;
    }
}
export class EntityNotFoundError extends Error {
    constructor(entityType, id) {
        super(`Could not find ${entityType} with id = ${id}`);
        this.name = "EntityNotFoundError";
        this.skipReporting = true;
        this.errorType = "NOT_FOUND";
        this.extensions = {
            name: this.name,
            errorType: this.errorType,
        };
    }
}
//# sourceMappingURL=error.js.map